<template>
  <b-card>
    <b-row>
      <!-- User Info: Left col -->
      <b-col class="d-flex justify-content-between flex-column md-6">
        <b-row class="align-items-center mb-2">
          <b-col cols="12" md="2">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="outline-secondary"
              class=""
              @click="$router.go(-1)"
            >
              <feather-icon icon="ArrowLeftIcon" class="mr-25" />
              <span>List</span>
            </b-button>
          </b-col>
          <b-col cols="12" md="6">
            <h4>Shift Details:</h4>
          </b-col>
          <b-col cols="12" md="6" />
        </b-row>
        <b-row>
          <b-col md="6">
            <b-row >
              <b-col md="6" class="pb-50 font-weight-bold"> Name </b-col>
              <b-col md="6" class="pb-50">
                {{ userData.name }}
              </b-col>
            </b-row>
          </b-col>
          <b-col md="6">
            <b-row >
              <b-col md="6" class="pb-50 font-weight-bold"> Description </b-col>
              <b-col md="6" class="pb-50">
                {{ userData.description }}
              </b-col>
            </b-row>
          </b-col>
          <b-col md="6">
            <b-row >
              <b-col md="6" class="pb-50 font-weight-bold">
                Shift Session 1
              </b-col>
              <b-col md="6" class="pb-50">
                {{ userData.session_1_start_from | formatTime }} - {{ userData.session_1_end_at | formatTime }}
              </b-col>
            </b-row>
          </b-col>
          <b-col md="6">
            <b-row >
              <b-col md="6" class="pb-50 font-weight-bold">
                Shift Session 2
              </b-col>
              <b-col md="6" class="pb-50">
                {{ userData.session_2_start_from | formatTime }} - {{ userData.session_2_end_at | formatTime }}
              </b-col>
            </b-row>
          </b-col>
          <b-col md="6">
            <b-row >
              <b-col md="6" class="pb-50 font-weight-bold">
                Total Work Hrs
              </b-col>
              <b-col md="6" class="pb-50">
                {{ userData.total_work_hrs }}
              </b-col>
            </b-row>
          </b-col>
          <b-col md="6">
            <b-row >
              <b-col md="6" class="pb-50 font-weight-bold">
                Shift Status
              </b-col>
              <b-col md="6" class="pb-50">
                {{ userData.status_label }}
              </b-col>
            </b-row>
          </b-col>
          <b-col md="6">
            <b-row >
              <b-col md="6" class="pb-50 font-weight-bold">
                Shift Timezone
              </b-col>
              <b-col md="6" class="pb-50">
                {{ userData.timezone }}
              </b-col>
            </b-row>
          </b-col>
          <b-col md="6">
            <b-row >
              <b-col md="6" class="pb-50 font-weight-bold">
                Shift Country
              </b-col>
              <b-col md="6" class="pb-50">
                {{ userData.country }}
              </b-col>
            </b-row>
          </b-col>
         
        </b-row>
      </b-col>
    </b-row>
    <b-row>
      <b-col v-for="(data, index) in customFields" v-bind:key="index" md="6">
        <b-row>
          <b-col md="6" class="pb-50 font-weight-bold">
            {{ data.label }}
          </b-col>
          <b-col md="6" class="pb-50">
            {{ userData.get_customfields_data["field_" + data.id] }}
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import { BCard, BRow, BCol, BButton, VBTooltip } from "bootstrap-vue";

import Ripple from "vue-ripple-directive";
import Vue from "vue";
import VueCookies from "vue-cookies";
Vue.use(VueCookies);

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BButton,
  },
  directives: {
    Ripple,
    "b-tooltip": VBTooltip,
  },
  props: {
    userData: {
      type: Object,
      required: true,
    },
    customFields: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      userDataLocal: this.$cookies.get("userData"),
    };
  },
  methods: {
    openWindow(link) {
      window.open(link);
    },
  },
};
</script>

<style>
</style>
